import SignInUsersTable from "@/v2-backoffice-client/signIn/SignInUsersTable"
import SignInPeriodSelect from "@/v2-backoffice-client/signIn/SignInPeriodSelect"
import { useSignInSharingRisks } from "@/v2-backoffice-client/signIn/useSignInSharingRisks"
import type { Period } from "@/v2-backoffice-client/signIn/signIn.period"

export type SignInUsersTabProps = {
  period: Period
  onPeriodChange(value: Period): void
}

// One row per user in the window, ranked worst-first by sharing-risk score —
// risk is an aggregate across a user's events, so this is where it's shown (not
// on individual event rows). Owns its own rollup query for the period.
function SignInUsersTab(props: SignInUsersTabProps) {
  const { period, onPeriodChange } = props
  const { risks, loading, error, refetch } = useSignInSharingRisks(period)

  return (
    <SignInUsersTable
      risks={risks}
      isLoading={loading}
      error={error}
      onRefresh={refetch}
      toolbarExtra={
        <SignInPeriodSelect value={period} onChange={onPeriodChange} />
      }
    />
  )
}

export default SignInUsersTab
